import { render, staticRenderFns } from "./PFDistribution.vue?vue&type=template&id=48e065b4"
import script from "./PFDistribution.vue?vue&type=script&lang=js"
export * from "./PFDistribution.vue?vue&type=script&lang=js"
import style0 from "./PFDistribution.vue?vue&type=style&index=0&id=48e065b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports